import { useEffect, useState } from 'react';
import CompanyProjectsView from 'components/widgets/Dashboard/CompanyGroups/CompanyProjectsView';
import CompanyView from 'components/widgets/Dashboard/CompanyGroups/CompanyView';
import { useGroupData } from 'hooks/useGroupData';
import { useDashboardGroupId } from 'state/dashboard';

const useCompanyMenu = () => {
  const [companyMenu, setCompanyMenu] = useState<boolean>(false);
  const [companyId, setCurrentCompany] = useState<number>(0);
  const [currentCompanyUuid, setCurrentCompanyUuid] = useState<string>('');
  const [currentCompanyName, setCurrentCompanyName] = useState<string>('');

  return {
    companyMenu,
    setCompanyMenu,
    setCurrentCompany,
    currentCompanyUuid,
    setCurrentCompanyUuid,
    currentCompanyName,
    setCurrentCompanyName,
    companyId,
  };
};

const GroupDetails = () => {
  const [group] = useDashboardGroupId();
  const groupData = useGroupData(String(group));

  const {
    companyMenu,
    setCompanyMenu,
    setCurrentCompany,
    currentCompanyUuid,
    setCurrentCompanyUuid,
    currentCompanyName,
    setCurrentCompanyName,
    companyId,
  } = useCompanyMenu();

  useEffect(() => {
    return () => {
      setCompanyMenu(false);
    };
  }, [group, setCompanyMenu]);

  if (companyMenu) {
    return (
      <CompanyProjectsView
        setCompanyMenu={setCompanyMenu}
        currentCompanyName={currentCompanyName}
        currentCompanyUuid={currentCompanyUuid}
        companyId={companyId}
        groupData={groupData}
      />
    );
  }

  return (
    <CompanyView
      companyMenu={companyMenu}
      setCompanyMenu={setCompanyMenu}
      setCurrentCompany={setCurrentCompany}
      setCurrentCompanyUuid={setCurrentCompanyUuid}
      setCurrentCompanyName={setCurrentCompanyName}
      groupData={groupData}
    />
  );
};

export default GroupDetails;
